import { onSubmit } from '../../handlers';

export const onCheck = (formikProps, stateProps, navSections) => {
  onSubmit(formikProps, stateProps);
  stateProps.onPreviewOpen();
};

export const setInitialValues = (props, survey) => {
  let initialValues = '';
  if (props.stateProps.sectionData.sectionName === 'resumes') {
    const data = survey['member'];
    initialValues = { jobSeekerData: data };
  } else {
    const resumeIndex = props.stateProps.sectionData.resumeIndex;
    const sectionName = props.stateProps.sectionData.sectionName;
    const resumeData = props.stateProps.dataToSave.saved.resumes[resumeIndex];
    if (typeof resumeData[sectionName] === 'undefined') {
      let newData = [];
      newData[0] = {};
      initialValues = { jobSeekerData: newData };
    } else {
      initialValues = { jobSeekerData: resumeData[sectionName] };
    }
    if (props.stateProps.sortableList.length > 1) {
      const jobSeekerData = props.stateProps.sortableList;
      initialValues = { jobSeekerData };
    }
  }
  return initialValues;
};